import {LANGUAGE} from '@/common/utils/constants';

export const MANAGEMENT_PAGE = {
	[LANGUAGE.en.short]: {
		created: "Created",
		noResults: 'There are no results matching your search and filters.',
		edit: "Edit",
		preview: "Preview",
		publish: "Publish",
		archive: "Archive",
		asignee: "Asignee",
		validator: "Validator",
		owner: "Owner",
		team: "Team",
		submitted: "Submitted",
		published: "Published",
		days: "Days",
		export: "Export projects",
		exporting: "Exporting...",
		pageTitle: "Manage Content",
		filterPlaceholder: "Search for title, id or reference owner",
		assign: "Assign",
		startReview: "Start review",
		finishReview: "Finish review",
		validate: "Validate",
		resend: "Resend",
		unpublish: "Unpublish",
		unarchive: "Unarchive",
		continueDraft: "Continue draft",
		titlePlaceholder: "Title is not added",
		clientNamePlaceholder: "Client name is not added",
		invalidate: 'Invalidate',
		sortBy: "Sort By",
		initialSubmission: 'Initial Submission',
		sortFilters: {
			id: "Project ID Oldest",
			management_dateSubmitted: "Newest created",
			management_firstDatePublish: "Last published",
			owner: "Reference owner",
			id_asc: 'Project ID Asc.',
			id_desc: 'Project ID Desc.',
			management_lastModifiedDate: "Oldest",
			management_lastModifiedDate_asc: "Oldest",
			management_lastModifiedDate_desc: "Latest",
			management_datePublish: "Oldest",
			management_datePublish_asc: "Oldest",
			management_datePublish_desc: "Latest",
			management_dateArchived: "Oldest",
			management_dateArchived_asc: "Oldest",
			management_dateArchived_desc: "Latest",
		},
		delete: "Delete",
		submitedInFR: "Submitted in French",
		submitedInDE: "Submitted in German",
		submitedInIT: "Submitted in Italian",
		submitedInJA: "Submitted in Japanese",
		submitedInES: "Submitted in Spanish",
		view: "View",
		backToDraft: "Back to RO",
		reject: 'Reject',
		manageTimeOff: "Manage Time Off",
		addNewTimeOff: "Add New Time Off",
		currentTimeOffs: "Current Days Off"
	},
	[LANGUAGE.it.short]: {
		created: "Creato",
		noResults: 'Non ci sono risultati che corrispondono alla ricerca e ai filtri.',
		edit: "Modificare",
		preview: "Anteprima",
		publish: "Pubblicare",
		archive: "Archivio",
		asignee: "Asigne",
		validator: "Validatore",
		owner: "Proprietario",
		team: "Squadra",
		submitted: "Presentato",
		published: "Pubblicato",
		days: "Giorni",
		export: "Progetti di esportazione",
		exporting: "Esportazione ...",
		pageTitle: "Gestisci i contenuti",
		filterPlaceholder: "Cerca titolo, ID o proprietario di riferimento",
		assign: "Assegnare",
		startReview: "Inizia la revisione",
		finishReview: "Termina la recensione",
		validate: "Convalidare",
		resend: "RECEND",
		unpublish: "Non pubblicato",
		unarchive: "Unarchive",
		continueDraft: "Continua il progetto",
		titlePlaceholder: "Il titolo non è aggiunto",
		clientNamePlaceholder: "Il nome del cliente non viene aggiunto",
		invalidate: 'Invalidare',
		sortBy: "Ordina per",
		initialSubmission: 'Invio iniziale',
		sortFilters: {
			id: "ID progetto più vecchio",
			management_dateSubmitted: "Il più recente creato",
			management_firstDatePublish: "Ultimo pubblicato",
			owner: "Proprietario di riferimento",
			id_asc: 'ID progetto asc',
			id_desc: 'ID progetto disc',
			management_lastModifiedDate: "Più vecchio",
			management_lastModifiedDate_asc: "Più vecchio",
			management_lastModifiedDate_desc: "Più recente",
			management_datePublish: "Più vecchio",
			management_datePublish_asc: "Più vecchio",
			management_datePublish_desc: "Più recente",
			management_dateArchived: "Più vecchio",
			management_dateArchived_asc: "Più vecchio",
			management_dateArchived_desc: "Più recente",
		},
		delete: "Eliminare",
		submitedInFR: "Inviato in francese",
		submitedInDE: "Inviato in tedesco",
		submitedInIT: "Inviato in italiano",
		submitedInJA: "Inviato in giapponese",
		submitedInES: "Inviato in spagnolo",
		view: "visualizzazione",
		backToDraft: "Torniamo a RO",
		reject: 'Rifiutare'
	},
	[LANGUAGE.de.short]: {
		created: "Erstellt",
		noResults: 'Es gibt keine Ergebnisse, die mit Ihrer Suche und Filtern entsprechen.',
		edit: "Bearbeiten",
		preview: "Vorschau",
		publish: "Veröffentlichen",
		archive: "Archiv",
		asignee: "Assigne",
		validator: "Validator",
		owner: "Inhaber",
		team: "Mannschaft",
		submitted: "Eingereicht",
		published: "Veröffentlicht",
		days: "Tage",
		export: "Exportprojekte",
		exporting: "Exportieren ...",
		pageTitle: "Inhalte verwalten",
		filterPlaceholder: "Suchen Sie nach Titel-, ID- oder Referenzbesitzer",
		assign: "Zuordnen",
		startReview: "Bewertung beginnen",
		finishReview: "Bewertung beenden",
		validate: "Bestätigen",
		resend: "Erneut senden",
		unpublish: "Unveröffentlicht",
		unarchive: "Nicht anarchiv",
		continueDraft: "Fortsetzen",
		titlePlaceholder: "Der Titel wird nicht hinzugefügt",
		clientNamePlaceholder: "Der Clientname wird nicht hinzugefügt",
		invalidate: 'Ungültig machen',
		sortBy: "Sortiere nach",
		initialSubmission: 'Erste Einreichung',
		sortFilters: {
			id: "Projekt-ID ältester",
			management_dateSubmitted: "Neueste erstellt",
			management_firstDatePublish: "Zuletzt veröffentlicht",
			owner: "Referenzinhaber",
			id_asc: 'Projekt-ID Aufsteigend',
			id_desc: 'Projekt-ID Beschreibung',
			management_lastModifiedDate: "Ältester",
			management_lastModifiedDate_asc: "Ältester",
			management_lastModifiedDate_desc: "Neuester",
			management_datePublish: "Ältester",
			management_datePublish_asc: "Ältester",
			management_datePublish_desc: "Neuester",
			management_dateArchived: "Ältester",
			management_dateArchived_asc: "Ältester",
			management_dateArchived_desc: "Neuester",
		},
		delete: "Löschen",
		submitedInFR: "Eingereicht auf Französisch",
		submitedInDE: "Eingereicht auf Deutsch",
		submitedInIT: "Eingereicht auf Italienisch",
		submitedInJA: "Eingereicht auf Japanisch",
		submitedInES: "Eingereicht auf Spanisch",
		view: "Sicht",
		backToDraft: "Zurück zu RO",
		reject: 'Ablehnen'
	},
	[LANGUAGE.fr.short]: {
		created: "Créé",
		noResults: 'Il n\'y a aucun résultat correspond à votre recherche et à vos filtres.',
		edit: "Éditer",
		preview: "Aperçu",
		publish: "Publier",
		archive: "Archive",
		asignee: "Assigné",
		validator: "Validateur",
		owner: "Propriétaire",
		team: "Équipe",
		submitted: "Soumis",
		published: "Publié",
		days: "Journées",
		export: "Projets d'exportation",
		exporting: "Exportation ...",
		pageTitle: "Gérer le contenu",
		filterPlaceholder: "Rechercher le titre, l'identifiant ou le propriétaire de référence",
		assign: "Attribuer",
		startReview: "Commencer à réviser",
		finishReview: "Termine l'analyse",
		validate: "Valider",
		resend: "Repenser",
		unpublish: "Inébranlable",
		unarchive: "Non archisif",
		continueDraft: "Continuer le projet",
		titlePlaceholder: "Le titre n'est pas ajouté",
		clientNamePlaceholder: "Le nom du client n'est pas ajouté",
		invalidate: 'Invalider',
		sortBy: "Trier par",
		initialSubmission: 'Soumission initiale',
		sortFilters: {
			id: "ID de projet le plus ancien",
			management_dateSubmitted: "Dernière création",
			management_firstDatePublish: "Dernière publication",
			owner: "Propriétaire de la référence",
			id_asc: 'ID de projet asc.',
			id_desc: 'ID du projet desc.',
			management_lastModifiedDate: "Le plus ancien",
			management_lastModifiedDate_asc: "Le plus ancien",
			management_lastModifiedDate_desc: "Le plus récent",
			management_datePublish: "Le plus ancien",
			management_datePublish_asc: "Le plus ancien",
			management_datePublish_desc: "Le plus récent",
			management_dateArchived: "Le plus ancien",
			management_dateArchived_asc: "Le plus ancien",
			management_dateArchived_desc: "Le plus récent",
		},
		delete: "Supprimer",
		submitedInFR: "Soumis en français",
		submitedInDE: "Soumis en allemand",
		submitedInIT: "Soumis en italien",
		submitedInJA: "Soumis en japonais",
		submitedInES: "Soumis en espagnol",
		view: "voir",
		backToDraft: "Retour à RO",
		reject: 'Rejeter'
	},
	[LANGUAGE.ja.short]: {
		created: "作成済み",
		noResults: '検索とフィルターに一致する結果はありません。',
		edit: "編集",
		preview: "プレビュー",
		publish: "公開",
		archive: "記録",
		asignee: "じゅたくしゃ",
		validator: "バリデーター",
		owner: "オーナー",
		team: "チーム",
		submitted: "提出",
		published: "公開",
		days: "日々",
		export: "輸出プロジェクト",
		exporting: "エクスポート...",
		pageTitle: "コンテンツの管理",
		filterPlaceholder: "タイトル、ID、または参照所有者を検索します",
		assign: "割当",
		startReview: "レビューを開始します",
		finishReview: "レビューを完了します",
		validate: "検証",
		resend: "再送信",
		unpublish: "未発表",
		unarchive: "未アーティ",
		continueDraft: "ドラフトを続けます",
		titlePlaceholder: "タイトルは追加されていません",
		clientNamePlaceholder: "クライアント名は追加されていません",
		invalidate: '無効にする',
		sortBy: "並び替え",
		initialSubmission: '最初の提出',
		sortFilters: {
			id: "プロジェクトID最古",
			management_dateSubmitted: "最新の作成",
			management_firstDatePublish: "最終公開",
			owner: "参照所有者",
			id_asc: 'プロジェクトID最古',
			id_desc: 'プロジェクトID最新',
			management_lastModifiedDate: "最古",
			management_lastModifiedDate_asc: "最古",
			management_lastModifiedDate_desc: "最新",
			management_datePublish: "最古",
			management_datePublish_asc: "最古",
			management_datePublish_desc: "最新",
			management_dateArchived: "最古",
			management_dateArchived_asc: "最古",
			management_dateArchived_desc: "最新",
		},
		delete: "消去",
		submitedInFR: "フランス語で提出",
		submitedInDE: "ドイツ語で提出",
		submitedInIT: "イタリア語で提出",
		submitedInJA: "日本語で提出",
		submitedInES: "スペイン語で提出",
		view: "意見",
		backToDraft: "ROに戻る",
		reject: '拒否する',
	},
	[LANGUAGE.es.short]: {
		created: "Creado",
		noResults: 'No hay resultados que coincidan con su búsqueda y filtros.',
		edit: "Editar",
		preview: "Vista previa",
		publish: "Publicar",
		archive: "Archivo",
		asignee: "Asignado",
		validator: "Validador",
		owner: "Propietario",
		team: "Equipo",
		submitted: "Enviado",
		published: "Publicado",
		days: "Días",
		export: "Exportar proyectos",
		exporting: "Exportando...",
		pageTitle: "Gestionar Contenido",
		filterPlaceholder: "Buscar por título, ID o propietario de referencia",
		assign: "Asignar",
		startReview: "Iniciar revisión",
		finishReview: "Finalizar revisión",
		validate: "Validar",
		resend: "Reenviar",
		unpublish: "Despublicar",
		unarchive: "Desarchivar",
		continueDraft: "Continuar borrador",
		titlePlaceholder: "El título no está agregado",
		clientNamePlaceholder: "El nombre del cliente no está agregado",
		invalidate: 'Invalidar',
		sortBy: "Ordenar por",
		initialSubmission: 'Envío inicial',
		sortFilters: {
			id: "ID del proyecto más antiguo",
			management_dateSubmitted: "Más reciente creado",
			management_firstDatePublish: "Último publicado",
			owner: "Propietario de referencia",
			id_asc: 'ID del proyecto asc.',
			id_desc: 'ID del proyecto desc.',
			management_lastModifiedDate: "Más antiguo",
			management_lastModifiedDate_asc: "Más antiguo",
			management_lastModifiedDate_desc: "Más reciente",
			management_datePublish: "Más antiguo",
			management_datePublish_asc: "Más antiguo",
			management_datePublish_desc: "Más reciente",
			management_dateArchived: "Más antiguo",
			management_dateArchived_asc: "Más antiguo",
			management_dateArchived_desc: "Más reciente",
		},
		delete: "Eliminar",
		submitedInFR: "Enviado en francés",
		submitedInDE: "Enviado en alemán",
		submitedInIT: "Enviado en italiano",
		submitedInJA: "Enviado en japonés",
		submitedInES: "Enviado en español",
		view: "Ver",
		backToDraft: "Volver a RO",
		reject: 'Rechazar'
	}
}
